import { render, staticRenderFns } from "./NicheOrderForm.vue?vue&type=template&id=201bb684"
import script from "./NicheOrderForm.vue?vue&type=script&lang=js"
export * from "./NicheOrderForm.vue?vue&type=script&lang=js"
import style0 from "./NicheOrderForm.vue?vue&type=style&index=0&id=201bb684&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports